import { render, staticRenderFns } from "./AnnotationLinksPreview.vue?vue&type=template&id=34d4c1bc&scoped=true"
import script from "./AnnotationLinksPreview.vue?vue&type=script&lang=js"
export * from "./AnnotationLinksPreview.vue?vue&type=script&lang=js"
import style0 from "./AnnotationLinksPreview.vue?vue&type=style&index=0&id=34d4c1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4c1bc",
  null
  
)

export default component.exports